import {
  REPORT_BATCH_HISTORY_SEARCH,
  REPORT_BATCH_HISTORY_SEARCH_SUCCESS,
  REPORT_BATCH_HISTORY_SEARCH_FAILURE,
  REPORT_BATCH_HISTORY_CLEAR,
  REPORT_BATCH_HISTORY_RESEND,
  REPORT_BATCH_HISTORY_RESEND_SUCCESS,
  REPORT_BATCH_HISTORY_RESEND_FAILURE
} from './mutation-types'

export default {
  state: {
    reportBatchHistories: null,
    reportBatchHistoriesCurrentPage: null,
    reportBatchHistoriesNextPage: null,
    reportBatchHistoriesTotalCount: 0,
    reportBatchHistoriesErrorCount: 0,
    reportBatchHistoriesUnsendCount: 0,
    searchParams: null
  },
  getters: {
    reportBatchHistories: state => {
      return state.reportBatchHistories
    },
    reportBatchHistoriesNextPage: state => {
      return state.reportBatchHistoriesNextPage
    },
    reportBatchHistoriesTotalCount: state => {
      return state.reportBatchHistoriesTotalCount
    },
    reportBatchHistoriesErrorCount: state => {
      return state.reportBatchHistoriesErrorCount
    },
    reportBatchHistoriesUnsendCount: state => {
      return state.reportBatchHistoriesUnsendCount
    },
    reportBatchHistoriesCurrentPage: state => {
      return state.reportBatchHistoriesCurrentPage
    },
    reportBatchHistoriesSearchParams: state => {
      return state.searchParams
    }
  },
  actions: {
    [REPORT_BATCH_HISTORY_SEARCH] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var url = '/batch_send'
        var loadparams = true
        var data = {}
        var callback = () => {}

        if (params) {
          if (params.loadparams) {
            loadparams = params.loadparams
          }
          if (params.callback) {
            callback = params.callback
          }

          if (params.url && !params.clear) {
            url = params.url
          }
          if (params.clear) {
            state.reportBatchHistories = null
            state.reportBatchHistoriesCurrentPage = null
            state.reportBatchHistoriesNextPage = null
            state.reportBatchHistoriesTotalCount = 0
          }
          state.searchParams = params.data
          data = params.data
        }
        dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(REPORT_BATCH_HISTORY_SEARCH_FAILURE, {data: res.data, callback: callback})
              reject()
            } else {
              commit(REPORT_BATCH_HISTORY_SEARCH_SUCCESS, {data: res.data, callback: callback})
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [REPORT_BATCH_HISTORY_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(REPORT_BATCH_HISTORY_CLEAR)
      }, sleep)
    },
    [REPORT_BATCH_HISTORY_RESEND] ({dispatch, state, commit}, params) {
      console.log('REPORT_BATCH_HISTORY_RESEND')
      var url = '/batch_send/resend'

      var data = {}
      var callback = () => {}

      if (params) {
        if (params.callback) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPatch', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_BATCH_HISTORY_RESEND_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_BATCH_HISTORY_RESEND_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [REPORT_BATCH_HISTORY_SEARCH_FAILURE] (state, data) {
      console.log('REPORT_BATCH_HISTORY_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [REPORT_BATCH_HISTORY_SEARCH_SUCCESS] (state, params) {
      console.log('REPORT_BATCH_HISTORY_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.reportBatchHistories = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.reportBatchHistoriesNextPage = null
        }
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.reportBatchHistories = state.reportBatchHistories.concat(data.data)
          state.reportBatchHistoriesCurrentPage = data.meta['current-page']
        } else {
          state.reportBatchHistories = data.data
          state.reportBatchHistoriesCurrentPage = 1
        }

        if (data.meta && data.meta['next-page']) {
          state.reportBatchHistoriesNextPage = data.links['next']
        } else {
          state.reportBatchHistoriesNextPage = null
        }
      }

      // 検索件数を取得
      state.reportBatchHistoriesTotalCount = 0
      if (data.meta && data.meta['total-count']) {
        state.reportBatchHistoriesTotalCount = data.meta['total-count']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [REPORT_BATCH_HISTORY_CLEAR] (state) {
      state.reportBatchHistories = null
    },
    [REPORT_BATCH_HISTORY_RESEND_SUCCESS] (state, params) {
      console.log('REPORT_BATCH_HISTORY_RESEND_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    },
    [REPORT_BATCH_HISTORY_RESEND_FAILURE] (state, params) {
      console.log('REPORT_BATCH_HISTORY_RESEND_FAILURE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report-batch-history.js